module.exports = __webpack_public_path__ + "static/media/general_sport_icon-01.397a352c.png";